import React, { useState, useEffect, useRef } from "react";
import "./LoadSlider.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { Input } from "reactstrap";
import { decimalPlaces } from "../../utils/formatters";

const DEFAULT_MAX = 12;

const LoadSlider = ({
  onChange,
  value,
  lightText,
  title = "Quantidade",
  max,
  step: stepProp,
  textColor,
}) => {
  const step = stepProp || 0.5;
  const decimals = decimalPlaces(step);
  const minValue = step;
  const color = textColor || (lightText ? "#fff" : "#2E384D");
  const inputColor = textColor || "#D3D3D3";
  const [maxValue, setMaxValue] = useState(DEFAULT_MAX);
  const inputRef = useRef(null);
  // Draft text while the user is typing in the input; null means "mirror the
  // parent value" (e.g. when the slider drives the change).
  const [draft, setDraft] = useState(null);

  const effectiveValue = value || minValue;

  const clamp = (val) => Math.min(Math.max(val, minValue), maxValue);

  const displayValue = draft !== null ? draft : parseFloat(effectiveValue).toFixed(decimals);

  const handleFocusCursor = () => {
    // Bank-transfer style input: keep the cursor at the end so digits fill
    // from the right.
    if (inputRef.current) {
      const { length } = inputRef.current.value;
      inputRef.current.setSelectionRange(length, length);
    }
  };

  const handleInputChange = (e) => {
    // Digits fill from the right with a fixed number of decimals
    // (value = digits / 10^decimals); typing shifts left, backspace shifts right.
    const digits = e.target.value.replace(/\D/g, "");
    const numeric = digits === "" ? 0 : parseInt(digits, 10) / (10 ** decimals);
    setDraft(numeric.toFixed(decimals));
    onChange(clamp(numeric));
  };

  const handleBlur = () => {
    // Stop editing: snap the display back to the (clamped) parent value.
    setDraft(null);
  };

  useEffect(() => {
    if (max) {
      setMaxValue(max);
    }
  }, [max]);

  return (
    <div className="load-slider-container">
      <div className="load-slider-info">
        <h3 style={{ color }}>{title}</h3>
        <div
          style={{
            display: "inline-flex",
            alignItems: "right",
            justifyContent: "center",
            color: "#D3D3D3",
            cursor: "default",
          }}
        >
          <Input
            value={displayValue}
            className="number-input"
            type="text"
            inputMode="decimal"
            onChange={handleInputChange}
            onFocus={handleFocusCursor}
            onClick={handleFocusCursor}
            onBlur={handleBlur}
            innerRef={inputRef}
            style={{
              width: "60px",
              height: "40px",
              display: "block",
              textAlign: "right",
              align: "right",
              backgroundColor: "transparent",
              color: inputColor,
              fontSize: "20px",
              fontWeight: "bold",
              border: "none",
              paddingRight: "5px",
            }}
          />
          <b
            style={{
              paddingTop: "12px",
              paddingLeft: "2px",
              color: inputColor,
            }}
          >
            m³
          </b>
        </div>
      </div>

      <Slider
        onChange={onChange}
        value={parseFloat(effectiveValue).toFixed(decimals)}
        min={minValue}
        max={maxValue}
        step={step}
        style={{ marginTop: "10px", color: "#1D84C6" }}
      />
    </div>
  );
};

export default LoadSlider;
